import React from 'react';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPolicy() {
  return <div className="min-h-screen w-full bg-gradient-to-b from-[#e6f7f7] to-white font-sans text-gray-900" data-id="element-151">
      {/* Header */}
      <header className="w-full max-w-[1728px] mx-auto px-6 md:px-[75px] py-[18px] flex items-center justify-between bg-white/80 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-100" data-id="element-152">
        <a href="/" className="flex-shrink-0" data-id="element-153">
          <img src="https://cdn.magicpatterns.com/uploads/msJLKApK3nKnZMALsRg6Xr/Logo2BName_AptOpt(1).svg" alt="Noris - Appointment Optimiser" className="h-11 w-auto" data-id="element-154" />
        </a>
        <a href="/" className="flex items-center gap-2 text-[13.6px] font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-155">
          <ArrowLeft className="w-4 h-4" data-id="element-156" />
          Back to Home
        </a>
      </header>

      {/* Content */}
      <main className="w-full max-w-[900px] mx-auto px-6 py-16" data-id="element-157">
        <h1 className="text-[36px] font-bold text-gray-900 mb-12 text-center" data-id="element-158">
          Noris Technologies Privacy Policy
        </h1>

        {/* Contact Details */}
        <section className="mb-12" data-id="element-159">
          <h2 className="text-[20px] font-semibold text-gray-900 mb-4" data-id="element-160">
            Our contact details
          </h2>
          <div className="space-y-2 text-[15px] text-gray-600" data-id="element-161">
            <p data-id="element-162">
              <span className="text-gray-900" data-id="element-163">Name:</span> Tom Ash-Miles
            </p>
            <p data-id="element-164">
              <span className="text-gray-900" data-id="element-165">Address:</span> 121 Bath Road,
              SN12 8HN
            </p>
            <p data-id="element-166">
              <span className="text-gray-900" data-id="element-167">Phone Number:</span> 07772499421
            </p>
            <p data-id="element-168">
              <span className="text-gray-900" data-id="element-169">E-mail:</span>{' '}
              <a href="mailto:tom@noris.uk" className="text-[#0088a9] hover:underline" data-id="element-170">
                tom@noris.uk
              </a>
            </p>
          </div>
        </section>

        {/* Type of Personal Information */}
        <section className="mb-12" data-id="element-171">
          <h2 className="text-[20px] font-semibold text-gray-900 mb-4" data-id="element-172">
            The type of personal information we collect
          </h2>
          <p className="text-[15px] text-gray-600 mb-4" data-id="element-173">
            We currently collect and process the following information:
          </p>
          <ul className="list-disc list-inside space-y-2 text-[15px] text-gray-600 ml-4" data-id="element-174">
            <li data-id="element-175">
              Names of our customers, suppliers and other business contacts
            </li>
            <li data-id="element-176">
              Contact information (such as email addresses, phone numbers, and
              addresses)
            </li>
            <li data-id="element-177">Customer staff (appointment holder) names</li>
            <li data-id="element-178">
              Financial information (such as bank account details, invoices, and
              payment records)
            </li>
          </ul>
        </section>

        {/* How We Get Information */}
        <section className="mb-12" data-id="element-179">
          <h2 className="text-[20px] font-semibold text-gray-900 mb-4" data-id="element-180">
            How we get the personal information and why we have it
          </h2>
          <p className="text-[15px] text-gray-600 mb-4" data-id="element-181">
            Most of the personal information we process is provided to us
            directly by you for one of the following reasons:
          </p>
          <ul className="list-disc list-inside space-y-2 text-[15px] text-gray-600 ml-4" data-id="element-182">
            <li data-id="element-183">
              To identify, contact, and support customers in the provision of
              our services
            </li>
            <li data-id="element-184">
              To store and display to your organisation the names of
              appointment-holders within your organisation
            </li>
            <li data-id="element-185">To process payments and maintain financial records</li>
            <li data-id="element-186">To communicate with you about our services</li>
          </ul>
        </section>

        {/* Lawful Basis */}
        <section className="mb-12" data-id="element-187">
          <h2 className="text-[20px] font-semibold text-gray-900 mb-4" data-id="element-188">
            Under the UK General Data Protection Regulation (UK GDPR), the
            lawful bases we rely on for processing this information are:
          </h2>
          <ul className="list-disc list-inside space-y-2 text-[15px] text-gray-600 ml-4" data-id="element-189">
            <li data-id="element-190">
              <strong data-id="element-191">Your consent.</strong> You are able to remove your consent
              at any time. You can do this by contacting us at tom@noris.uk
            </li>
            <li data-id="element-192">
              <strong data-id="element-193">We have a contractual obligation.</strong> We need to
              process your data to fulfil our contract with you.
            </li>
            <li data-id="element-194">
              <strong data-id="element-195">We have a legitimate interest.</strong> We have a
              legitimate interest in processing your data for the purposes of
              running our business and providing our services.
            </li>
          </ul>
        </section>

        {/* How We Store Information */}
        <section className="mb-12" data-id="element-196">
          <h2 className="text-[20px] font-semibold text-gray-900 mb-4" data-id="element-197">
            How we store your personal information
          </h2>
          <p className="text-[15px] text-gray-600 mb-4" data-id="element-198">
            Your information is securely stored on encrypted servers and
            cloud-based systems with appropriate security measures in place.
          </p>
          <p className="text-[15px] text-gray-600" data-id="element-199">
            We keep your personal information for as long as necessary to
            provide our services to you and to comply with our legal
            obligations. When your information is no longer required, we will
            securely dispose of it.
          </p>
        </section>

        {/* Your Rights */}
        <section className="mb-12" data-id="element-200">
          <h2 className="text-[20px] font-semibold text-gray-900 mb-4" data-id="element-201">
            Your data protection rights
          </h2>
          <p className="text-[15px] text-gray-600 mb-4" data-id="element-202">
            Under data protection law, you have rights including:
          </p>
          <ul className="list-disc list-inside space-y-2 text-[15px] text-gray-600 ml-4" data-id="element-203">
            <li data-id="element-204">
              <strong data-id="element-205">Your right of access</strong> - You have the right to ask
              us for copies of your personal information.
            </li>
            <li data-id="element-206">
              <strong data-id="element-207">Your right to rectification</strong> - You have the right
              to ask us to rectify personal information you think is inaccurate.
              You also have the right to ask us to complete information you
              think is incomplete.
            </li>
            <li data-id="element-208">
              <strong data-id="element-209">Your right to erasure</strong> - You have the right to ask
              us to erase your personal information in certain circumstances.
            </li>
            <li data-id="element-210">
              <strong data-id="element-211">Your right to restriction of processing</strong> - You
              have the right to ask us to restrict the processing of your
              personal information in certain circumstances.
            </li>
            <li data-id="element-212">
              <strong data-id="element-213">Your right to object to processing</strong> - You have the
              right to object to the processing of your personal information in
              certain circumstances.
            </li>
            <li data-id="element-214">
              <strong data-id="element-215">Your right to data portability</strong> - You have the
              right to ask that we transfer the personal information you gave us
              to another organisation, or to you, in certain circumstances.
            </li>
          </ul>
          <p className="text-[15px] text-gray-600 mt-4" data-id="element-216">
            You are not required to pay any charge for exercising your rights.
            If you make a request, we have one month to respond to you.
          </p>
          <p className="text-[15px] text-gray-600 mt-4" data-id="element-217">
            Please contact us at{' '}
            <a href="mailto:tom@noris.uk" className="text-[#0088a9] hover:underline" data-id="element-218">
              tom@noris.uk
            </a>{' '}
            if you wish to make a request.
          </p>
        </section>

        {/* How to Complain */}
        <section className="mb-12" data-id="element-219">
          <h2 className="text-[20px] font-semibold text-gray-900 mb-4" data-id="element-220">
            How to complain
          </h2>
          <p className="text-[15px] text-gray-600 mb-4" data-id="element-221">
            If you have any concerns about our use of your personal information,
            you can make a complaint to us at{' '}
            <a href="mailto:tom@noris.uk" className="text-[#0088a9] hover:underline" data-id="element-222">
              tom@noris.uk
            </a>
            .
          </p>
          <p className="text-[15px] text-gray-600 mb-4" data-id="element-223">
            You can also complain to the ICO if you are unhappy with how we have
            used your data.
          </p>
          <div className="bg-gray-50 rounded-lg p-6 text-[15px] text-gray-600" data-id="element-224">
            <p className="font-semibold text-gray-900 mb-2" data-id="element-225">
              The ICO's address:
            </p>
            <p data-id="element-226">Information Commissioner's Office</p>
            <p data-id="element-227">Wycliffe House</p>
            <p data-id="element-228">Water Lane</p>
            <p data-id="element-229">Wilmslow</p>
            <p data-id="element-230">Cheshire</p>
            <p data-id="element-231">SK9 5AF</p>
            <p className="mt-4" data-id="element-232">
              <span className="text-gray-900" data-id="element-233">Helpline number:</span> 0303 123
              1113
            </p>
            <p className="mt-2" data-id="element-234">
              <span className="text-gray-900" data-id="element-235">ICO website:</span>{' '}
              <a href="https://www.ico.org.uk" target="_blank" rel="noopener noreferrer" className="text-[#0088a9] hover:underline" data-id="element-236">
                https://www.ico.org.uk
              </a>
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="w-full max-w-[1728px] mx-auto bg-gray-900 py-8 px-6 md:px-[75px]" data-id="element-237">
        <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-238">
          <a href="/" className="flex-shrink-0" data-id="element-239">
            <img src="https://cdn.magicpatterns.com/uploads/msJLKApK3nKnZMALsRg6Xr/Logo2BName_AptOpt(1).svg" alt="Noris - Appointment Optimiser" className="h-8 w-auto brightness-0 invert" data-id="element-240" />
          </a>
          <div className="flex items-center gap-4 text-[12px] text-gray-400" data-id="element-241">
            <span data-id="element-242">© 2025 Noris. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>;
}